import { get, patch, post } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    person_requests: []
  },

  getters: {},

  mutations: {
    retrievedpersonRequests: (state, personRequests) => {
      state.personRequests = personRequests;
    }
  },

  actions: {
    retrievePersonRequests: () => get('/person-requests'),

    // retrievePersonRequest: (_, building) => {
    //   return new Promise((resolve, reject) => {
    //     get(`/person-requests/${person_request}`)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // },

    store: (_, person_request) => post('/person-requests', person_request),

    update: (_, person_request) =>
      patch(`/person-requests/${person_request.id}`, person_request)
  }
};
